/** In-memory asset cache — tests and ephemeral sessions. */
export class MemoryAssetStore {
    assets = new Map();
    async get(assetId) {
        return this.assets.get(assetId) ?? null;
    }
    async put(asset) {
        this.assets.set(asset.assetId, asset);
    }
    async delete(assetId) {
        this.assets.delete(assetId);
    }
    async clear() {
        this.assets.clear();
    }
}
//# sourceMappingURL=memory-asset-store.js.map